import Honeybadger from 'honeybadger-js';
import { useEffect } from 'react';

import { WeddingWebsiteQuery } from './../generated/graphql';

const useHoneybadgerSetContext = (data: WeddingWebsiteQuery | undefined) => {
  useEffect(() => {
    if (data) {
      const { member, wedding, weddingWebsite } = data;

      Honeybadger.setContext({
        memberId: member?.id || '',
        weddingId: wedding?.id || '',
        weddingWebsiteId: weddingWebsite?.id || '',
      });
    }
  }, [data]);
};

export default useHoneybadgerSetContext;
